import AnimationController from "@controllers/animations";
import { ANIMATION_STATE } from "@controllers/fsm";
class EnemyAnimationController extends AnimationController {
    constructor(assetLoader, target) {
        const animations = {
            [ANIMATION_STATE.IDLE]: assetLoader.getPlayerAssets.animations.idle,
            [ANIMATION_STATE.WALK]: assetLoader.getPlayerAssets.animations.walking,
            [ANIMATION_STATE.RUN]: assetLoader.getPlayerAssets.animations.running,
        };
        super(animations, target);
    }
}
export default EnemyAnimationController;
